<template>
  <CustomSidebar
    style="overflow: auto"
    v-model:visible="this.visible"
    v-if="this.modelValue"
    :baseZIndex="1000"
    exitLabel="Close"
    position="full"
    @hide="$emit('close')"
  >
    <template #actions>
      <Button
        label="PDF"
        icon="pi pi-file-pdf pi-fw"
        class="p-button-danger"
        @click="exportToPDF"
      />
    </template>
    <div id="app" ref="document">
      <table id="table">
        <tr>
          <th style="width: 10%">
            <img
              src="/assets/layout/images/wilmar-logo.png"
              alt="Wilmar Logo"
              style="max-width: 100%; height: auto"
            />
          </th>
          <th colspan="3" :style="getCategoryStyle">{{ getCategoryTitle }}</th>
          <th style="width: 10%">
            <img
              src="/assets/layout/images/weptw-2.png"
              alt="Wilmar Logo"
              style="max-width: 100%; height: auto"
            />
          </th>
        </tr>
        <tr>
          <th colspan="5" style="background-color: #ffff00; color: #000000">
            Direction! <br />
            Must fill in the Permit Checklist data on the day of permit
            creation, if not, the permit will be automatically locked and the
            company will automatically unlinked.
          </th>
        </tr>
      </table>
      <br />
      <table id="table">
        <tr>
          <th style="width: 30%">Permit Status</th>
          <th style="width: 40%">Permit Number</th>
          <th style="width: 40%">Permit User</th>
        </tr>
        <tr>
          <td style="text-align: center">{{ permitStatus }}</td>
          <td style="text-align: center">{{ permitNumber }}</td>
          <td style="text-align: center">{{ permitUser }}</td>
        </tr>
      </table>
      <br />
      <table id="table">
        <thead>
          <tr>
            <th>Section</th>
            <th>Description</th>
            <th>Yes</th>
            <th>No</th>
            <th>NA</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in filteredItems" :key="index">
            <td>{{ item.numberSection }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.ValueYes ? "✓" : "" }}</td>
            <td>{{ item.ValueNo ? "✓" : "" }}</td>
            <td>{{ item.ValueNA ? "✓" : "" }}</td>
          </tr>
        </tbody>
      </table>
      <br />
      <table id="table" v-if="this.typePermitCheclist === 'pre'">
        <tr>
          <th>Verify Preparation By PIC</th>
        </tr>
        <tr>
          <td style="text-align: center; height: 50%">
            <br /><br /><br /><br /><br />
          </td>
        </tr>
      </table>
      <table id="table" v-if="this.typePermitCheclist === 'dur'">
        <tr>
          <th style="width: 50%">Verify During By PIC</th>
          <th style="width: 50%">Verify Post By PIC</th>
        </tr>
        <tr>
          <td style="text-align: center; height: 50%">
            <br /><br /><br /><br /><br />
          </td>
          <td style="text-align: center; height: 50%">
            <br /><br /><br /><br /><br />
          </td>
        </tr>
      </table>
      <br />
      <table id="table">
        <tr>
          <th style="width: 10%">
            <img
              src="/assets/layout/images/wilmar-logo.png"
              alt="Wilmar Logo"
              style="max-width: 100%; height: auto"
            />
          </th>
          <th colspan="3" :style="getCategoryStyle">{{ getCategoryTitle }}</th>
          <th style="width: 10%">
            <img
              src="/assets/layout/images/weptw-2.png"
              alt="Wilmar Logo"
              style="max-width: 100%; height: auto"
            />
          </th>
        </tr>
      </table>
    </div>
  </CustomSidebar>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  emits: ["close"],
  name: "hello",
  props: {
    isVisible: {
      type: Boolean,
      default: true,
    },
    typePermitCheclist: {
      type: String,
      default: "",
    },
    permitNumber: {
      type: String,
      default: "",
    },
    permitStatus: {
      type: String,
      default: "",
    },
    permitUser: {
      type: String,
      default: "",
    },
    permitCategory: {
      type: String,
      default: "",
    },
    modelValue: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      visible: false,
    };
  },
  watch: {
    isVisible(newVal) {
      this.visible = newVal;
    },
  },
  computed: {
    filteredArray() {
      var ret = {};
      for (let i in this.modelValue.Details) {
        let key = this.modelValue.Details[i].Description;
        let description = this.modelValue.Details[i].repair_type;
        ret[key] = {
          descriptions: description,
          desc: key,
          count: ret[key] && ret[key].count ? ret[key].count + 1 : 1,
        };
      }
      return Object.values(ret);
    },
    filteredItems() {
      if (!this.modelValue) return [];

      // If typePermitCheclist is PRE, filter items with section PRE
      if (this.typePermitCheclist === "pre") {
        return this.modelValue.filter((item) => item.section === "pre");
      } else if (this.typePermitCheclist === "dur") {
        return this.modelValue.filter((item) => item.section !== "pre");
      } else {
        // Otherwise return all items
        return this.modelValue;
      }
    },
    getCategoryTitle() {
      switch (this.permitCategory) {
        case "HOWP":
          return "HOT WORK PERMIT";
        case "WAHP":
          return "WORK AT HEIGHT PERMIT";
        case "CSEP":
          return "CONFINED SPACE WORK PERMIT";
        case "LOTO":
          return "LOTO WORK PERMIT";
        default:
          return "WORK PERMIT";
      }
    },
    getCategoryStyle() {
      let backgroundColor = "";

      switch (this.permitCategory) {
        case "HOWP":
          backgroundColor = "#FF0000"; // Red
          break;
        case "WAHP":
          backgroundColor = "#000000"; // Black
          break;
        case "CSEP":
          backgroundColor = "#FFA500"; // Orange
          break;
        case "LOTO":
          backgroundColor = "#FFFF00"; // Yellow
          break;
        default:
          backgroundColor = "#FFFFFF"; // White
      }

      return {
        backgroundColor: backgroundColor,
        color: ["HOWP", "COWP"].includes(this.permitCategory)
          ? "#FFFFFF"
          : "#000000",
        textAlign: "center",
        fontWeight: "bold",
      };
    },
  },
  methods: {
    exportToPDF() {
      let doc_width = 8.27;
      let doc_height = 11.69;
      let dpi = 96;
      let img_width = doc_width * dpi;
      //let img_height = doc_height * dpi;
      let win_width = img_width;
      //let win_height = img_height;

      let html2canvasOpts = {
        dpi: 300,
        scale: 4,
        width: img_width,
        windowWidth: win_width,
        windowHeight: doc_height * dpi,
        letterRendering: true,
        useCORS: true,
      };

      let jsPDFOpts = {
        orientation: "portrait",
        unit: "in",
        format: [doc_width, doc_height],
      };
      html2pdf()
        .from(this.$refs.document)
        .set({
          margin: [0.1, 0.1, 0.1, 0.1],
          filename: "PermitChecklist",
          image: { type: "jpeg", quality: 1 },
          html2canvas: html2canvasOpts,
          jsPDF: jsPDFOpts,
          pagebreak: { before: ".page-break", avoid: "img" },
        })
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() - 100,
              pdf.internal.pageSize.getHeight() - 10
            );
            pdf.text("my headder text", 10, 10);
          }
        })
        .save();
    },
  },

  mounted() {
    this.visible = this.isVisible;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

#table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  color: black;
}

#table td,
#table th,
#table tr {
  border: 1px solid black;
  padding: 8px;
}

#table th:nth-child(1) {
  width: 10%;
}

#table th:nth-child(2) {
  width: 60%;
}

#table th:nth-child(3),
#table th:nth-child(4),
#table th:nth-child(5) {
  width: 5%;
  text-align: center;
}

#table td:nth-child(3),
#table td:nth-child(4),
#table td:nth-child(5) {
  text-align: center;
}

#table tr:nth-child(even) {
  background-color: #f2f2f2;
}

#table tr:hover {
  background-color: #ddd;
}
</style>
